import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// If a login response includes an access_token, also set it as a Bearer header
// (used as a belt-and-braces alongside the cookie for environments that strip
// third-party cookies).
// localStorage is guarded because it can throw in Safari private mode, SSR,
// or when storage quotas are exhausted. In every case we already have the
// cookie / in-memory header as source of truth, so we log and move on.
function _storageWarn(op, err) {
  console.debug(`[api] localStorage ${op} unavailable`, err);
}

export function setBearer(token) {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    try { localStorage.setItem("access_token", token); } catch (err) { _storageWarn("set", err); }
  } else {
    delete api.defaults.headers.common["Authorization"];
    try { localStorage.removeItem("access_token"); } catch (err) { _storageWarn("remove", err); }
  }
}

// Bootstrap bearer from localStorage on module load (survives reloads even if
// cookies are blocked)
try {
  const t = localStorage.getItem("access_token");
  if (t) api.defaults.headers.common["Authorization"] = `Bearer ${t}`;
} catch (err) { _storageWarn("get", err); }

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
